import { ContentInfo } from '../interfaces';

/**
 * Content Informatin Top Section (1st group)
 */
export const CONTENT_INFO_BATCH_ONE: ContentInfo[][] = [
    [
        { label: 'File Name', key: 'fileName' },
        { label: 'File Type', key: 'fileType' },
    ],
    [
        { label: 'Uploaded by', key: 'createdBy', type: 'text' },
        { label: 'Date Uploaded', key: 'createdAt', type: 'date' },
    ],
    [
        { label: 'Date Added', key: 'createdAt', type: 'date' },
        { label: 'Date Modified', key: 'updatedAt', type: 'date' },
    ],
    [
        { label: 'Status', key: 'isActive' },
        { label: 'Tags', key: 'classification' },
    ],
];

/**
 * Content Informatin Bottom Section (2nd group)
 */
export const CONTENT_INFO_BATCH_TWO: ContentInfo[][] = [
    [
        { label: 'License Count', value: 2 },
        { label: 'Host Count', value: 2 },
    ],
    [
        { label: 'Playlist Count', value: 200 },
        { label: 'Screen Count', value: 2 },
    ],
];
